import React, { createContext, useContext, useMemo } from "react";

export const TEMPLATE_SIDES = {
  PRODUCT: "product",
  ENVIRONMENTAL: "environment",
};

export const getOppositeTemplateSide = (side) => (
  side === TEMPLATE_SIDES.ENVIRONMENTAL
    ? TEMPLATE_SIDES.PRODUCT
    : TEMPLATE_SIDES.ENVIRONMENTAL
);

const TemplateContext = createContext({
  side: TEMPLATE_SIDES.PRODUCT,
  withSide: (payload = {}) => ({ ...payload, side: TEMPLATE_SIDES.PRODUCT }),
});

export function TemplateProvider({ side, children }) {
  const value = useMemo(() => ({
    side,
    withSide: (payload = {}) => ({ ...payload, side }),
  }), [side]);

  return (
    <TemplateContext.Provider value={value}>
      {children}
    </TemplateContext.Provider>
  );
}

export const useTemplateContext = () => useContext(TemplateContext);
